// import blackDoor from '@/pages/TeamSetting/_TeamSettingId.vue';
// const dashboardList = () => import('@/pages/Dashboard/_DashboardList.vue');
const chartDetial = () => import('@/pages/Dashboard/_ChartDetial.vue');
// const clickImportList = () => import('@/pages/ClickImport/ClickImportList.vue');
// const clickImportDetial = () => import('@/pages/ClickImport/_ClickImportDetialId.vue');
// const clickImportSetTable = () => import('@/pages/ClickImport/_ClickImportSetTableId.vue');
const memberProfileList = () => import('@/pages/MemberProfile/MemberList.vue');
const memberDetial = () => import('@/pages/MemberProfile/_MemberDetial.vue');
const memberAnalysis = () => import('@/pages/Overview/MemberAnalysis.vue');
const dataAnalysis = () => import('@/pages/Overview/DataAnalysis.vue');
const salesAnalysis = () => import('@/pages/Overview/SalesAnalysis.vue');
const interactionAnalysis = () => import('@/pages/Overview/InteractionAnalysis.vue');

export default {
  name: 'dataOverview',
  meta: {
    key: 'dataOverview'
  },
  path: '/data-overview',
  redirect: {
    name: 'overview',
  },
  children: [
    {
      name: 'overview',
      icon: 'ic_common_home',
      path: '/data-overview/overview',
      meta: {
        permission: [],
      },
      redirect: {
        name: 'memberAnalysis',
      },
      children: [
        {
          name: 'memberAnalysis',
          path: '/data-overview/member-analysis',
          meta: {
            permission: [],
          },
          component: memberAnalysis,
        },
        {
          name: 'dataAnalysis',
          path: '/data-overview/data-analysis',
          meta: {
            permission: [],
          },
          component: dataAnalysis,
        },
        {
          name: 'salesAnalysis',
          path: '/data-overview/sales-analysis',
          meta: {
            permission: [],
          },
          component: salesAnalysis,
        },
        {
          name: 'interactionAnalysis',
          path: '/data-overview/interaction-analysis',
          meta: {
            permission: [],
          },
          component: interactionAnalysis,
        },
      ],
    },
    {
      name: 'chartDetial',
      path: '/data-overview/dashboard/chart-detial',
      meta: {
        permission: ['dashboard'],
        hidden: true
      },
      component: chartDetial,
      permission: ['dashboard'],
    },
    {
      name: 'members',
      icon: 'ic_common_audience',
      path: '/data-overview/members/list',
      meta: {
        permission: ['client'],
      },
      component: memberProfileList
    },
    {
      name: 'memberDetial',
      path: '/data-overview/members/member-detail/:id',
      meta: {
        hidden: true,
        permission: ['client'],
      },
      component: memberDetial,
    }
    // {
    //   name: 'dataCenter',
    //   icon: 'ic_common_datahub',
    //   path: '/data-center',
    //   meta: {
    //     permission: [],
    //   },
    //   redirect: {
    //     name: 'clickImport',
    //   },
    //   children: [
    //     {
    //       name: 'clickImport',
    //       path: '/data-overview/data-center/',
    //       meta: {
    //         permission: [],
    //       },
    //       redirect: {
    //         name: 'clickImportList',
    //       },
    //       children: [
    //         {
    //           name: 'clickImportList',
    //           meta: {
    //             permission: [],
    //           },
    //           path: '/data-overview/data-center/list',
    //           component: clickImportList,
    //         },
    //         {
    //           name: 'clickImportDetialId',
    //           meta: {
    //             permission: [],
    //           },
    //           path: '/data-overview/data-center/detial/:id',
    //           component: clickImportDetial,
    //         },
    //         {
    //           name: 'clickImportSetTableId',
    //           meta: {
    //             permission: [],
    //           },
    //           path: '/data-overview/data-center/set-table/:id',
    //           component: clickImportSetTable,
    //         },
    //       ],
    //     },
    //   ],
    // },
  ],
};
